
import React, { useEffect, useRef } from 'react'
import propTypes from 'prop-types'
import ZingChart from 'zingchart-react'
import TreeMapChartConfiguration from './TreeMapChartConfiguration'

// Timeout to delay event binding until ZingChart is fully initialized.
// This is a workaround for cases where the chart is not immediately ready for event binding after mount.
// If you update ZingChart or find a more robust event/callback, replace this with a proper readiness check.
const ZINGCHART_EVENT_BIND_DELAY_MS = 1500;

const TreeMapChartCard = (props) => {
	const chartRef = useRef(null);
	const chartId = useRef(`treemap-chart-${Math.random().toString(36).substr(2, 9)}`).current;

	// Destructure the callback prop
	const { onNodeClick } = props;

	const charData = TreeMapChartConfiguration(
		props.title,
		props.subtitle,
		props.series,
		props.mainColor,
		props.secondaryColor,
		props.percentage
	);

	useEffect(() => {
		const zc = window.zingchart || window.ZingChart;

		if (!zc) {
			console.error('ZingChart not available');
			return;
		}

		// Wait for chart to fully initialize before binding events.
		// If ZingChart provides a ready event/callback, use that instead of this timeout.
		const timer = setTimeout(() => {
			try {
				// For treemap, use 'node_click'
				zc.bind(chartId, 'node_click', function (p) {
					if (onNodeClick) {
						// Extract node information
						const nodeText = p.text || p.id || p.plotid;
						if (nodeText) {
							onNodeClick(nodeText);
						}
					}
				});
			} catch (error) {
				console.error('Error binding events:', error);
			}
		}, ZINGCHART_EVENT_BIND_DELAY_MS);

		return () => {
			clearTimeout(timer);
			if (zc && zc.unbind) {
				try {
					zc.unbind(chartId, 'node_click');
				} catch (e) {
					console.log('Unbind error:', e);
				}
			}
		};
		// Only depend on chartId and onNodeClick - these won't change unnecessarily
	}, [chartId, onNodeClick]);

	// Ensure the chart config has an ID
	const chartConfigWithId = {
		...charData,
		id: chartId,
		// Add this to ensure interactions are enabled
		plot: {
			...charData.plot,
			cursor: 'pointer'
		}
	};

	return (
		<div
			style={{
				position: 'relative',
				pointerEvents: 'auto',
				minHeight: props.height || 300
			}}
		>
			<ZingChart
				ref={chartRef}
				id={chartId}
				data={chartConfigWithId}
				height={props.height || 300}
				width="100%"
			/>
		</div>
	)
}

TreeMapChartCard.propTypes = {
	mainColor: propTypes.string,
	secondaryColor: propTypes.string,
	title: propTypes.string,
	subtitle: propTypes.string,
	series: propTypes.array,
	percentage: propTypes.number,
	totalServices: propTypes.number,
	percentajeValue: propTypes.number,
	label: propTypes.string,
	height: propTypes.number,
	onNodeClick: propTypes.func
}

TreeMapChartCard.defaultProps = {
	mainColor: '#D3D3D3',
	secondaryColor: '#ADADAD',
	totalServices: 0,
	percentajeValue: 0,
	label: 'label',
	height: 300
}

export default TreeMapChartCard